<template>
    <disclaimer class="demo-disclaimer">
        Caution! This is a development version for technical integration evaluation only. The system
        is not for clinical use!
    </disclaimer>
</template>

<script>
import Disclaimer from '../partials/Disclaimer.vue'

export default {
    name: 'DemoDisclaimer',
    components: { Disclaimer }
}
</script>

